var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlan4({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 327.242,
    height: 244.76,
    viewBox: "0 0 327.242 244.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3250",
    "data-name": "Group 3250",
    transform: "translate(-1421.879 -4147.267)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1240",
    "data-name": "Group 1240",
    transform: "translate(1421.879 4198.978)",
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2224",
    "data-name": "Path 2224",
    d: "M202.467,169.191s-1.632,39.35-8.818,38.59,4.928-43.716,4.928-43.716-30.626-24.993-44.459-26.855c0,0,12.972,41.863,6.193,39.329s-22.271-45.461-22.271-45.461-33.831-15-44.369,4.955-3.806,32.761,1.127,35.328,38.64,10.055,36.754,14.285-26.2,5.97-37.948-1.009c0,0,5.959,38.338,24.7,40.891s27.044-7.642,38.592-5.851,19.134,6.853,12.75,8.619-25.109-4.854-36.083.9-19.508,8.885-3.3,16.45,47.266,12.56,56.417.694l1.145-1.484a7.18,7.18,0,0,1-1.145,1.484c2.714,2.6,5.4,12.592,7.106,20.174.2,1.269.572,3.048,1.169,5.483h0c.219,1.09.389,1.978.506,2.6,2.514,16.672-6.686,42.27-6.686,42.27l3.409,1.851c14.126-24.652,4.975-49.8,4.975-49.8-5.211-19.462-1.329-34.44-1.329-34.44s36.988-10.9,27.491-39.792C223.321,194.682,214.647,176.272,202.467,169.191Z",
    transform: "translate(-88.092 -125.668)",
    fill: "#dfeafd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2225",
    "data-name": "Path 2225",
    d: "M408.016,157.16c-1.04-21.814-37.2-23.032-37.2-23.032s-31.523,30.83-38.574,30.178,21.805-31.624,21.805-31.624c-13.013-4.215-50.485,4.621-50.485,4.621s-7.113,42.5-13.786,40.133S298,140.124,298,140.124c-13.717,1.025-29.033,13.392-29.033,13.392-20.4,21.141,7.8,46.238,7.8,46.238s-2.783,14.677-15.473,29.42h0a50.863,50.863,0,0,0-5.935,7.434l3.508.774q.741-1.318,1.551-2.514l.011-.015.024-.033c.359-.49.874-1.185,1.511-2.03l0,0,0,0c1.534-1.863,2.6-3.253,3.3-4.271l.006-.009c4.662-5.879,11.178-13.44,14.66-14.56a7,7,0,0,1-.4-1.775c.126.566.259,1.156.4,1.775,3.17,14.189,32.72,22.946,50.2,23.2s11.231-6.07,3.911-15.711-26.636-11.778-31.551-16.009,3.9-5.438,14.858-2.124,14.082,15.692,31.718,21.376S387.9,199.5,387.9,199.5c-13.288,1.121-34.078-10.653-33.991-15.131s33.016,3.224,38.446,3.072S409.057,178.975,408.016,157.16Z",
    transform: "translate(-80.841 -122.61)",
    fill: "#b2cbfd",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1239",
    "data-name": "Group 1239",
    transform: "translate(1442 4147.267)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1238",
    "data-name": "Group 1238",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1015",
    "data-name": "Group 1015",
    transform: "translate(121.289 128.85)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_995",
    "data-name": "Group 995",
    transform: "translate(19.93)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_994",
    "data-name": "Group 994"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_993",
    "data-name": "Group 993"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_992",
    "data-name": "Group 992"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_991",
    "data-name": "Group 991"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_990",
    "data-name": "Group 990"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2228",
    "data-name": "Path 2228",
    d: "M2634.807,2420.781a1.017,1.017,0,0,1-.119.108,11.629,11.629,0,0,1-1.271.958c-2.74,1.821-6.965,3.33-11.911,4.566-17.974,4.509-45.443,5.524-45.443,5.524l-1.837-21.383s33.834-4.359,41.887-11.23c14.476-14.39,7.118-33.787,16.017-46.328a42.594,42.594,0,0,0,5.127,7.714,31.212,31.212,0,0,1,6.069,11.786C2648.21,2389.269,2643.951,2412.484,2634.807,2420.781Z",
    transform: "translate(-2574.226 -2352.997)",
    fill: "#ff6b36"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_997",
    "data-name": "Group 997",
    transform: "translate(67.211 51.671)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_996",
    "data-name": "Group 996"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2229",
    "data-name": "Path 2229",
    d: "M3266.094,3113.268c-2.739,1.82-6.965,3.329-11.911,4.565l6.443-21.746Z",
    transform: "translate(-3254.183 -3096.088)",
    fill: "#e54b13"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_999",
    "data-name": "Group 999",
    transform: "translate(60.441 6.774)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_998",
    "data-name": "Group 998"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2230",
    "data-name": "Path 2230",
    d: "M3156.821,2483.183c-.455,7.606,28.142,11.7,28.142,11.7l7.289-39.063s-22.032-9.036-25.869-3.746C3162.43,2457.525,3157.331,2474.664,3156.821,2483.183Z",
    transform: "translate(-3156.815 -2450.416)",
    fill: "#265784"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1001",
    "data-name": "Group 1001",
    transform: "translate(61.127 17.914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1000",
    "data-name": "Group 1000"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2231",
    "data-name": "Path 2231",
    d: "M3194.728,2617.3l-3.12,11.4c.4-1.259-20.351-3.181-24.079-6.589-2.181-1.994.245-10.716,3.12-11.4C3175.415,2609.579,3194.176,2618.948,3194.728,2617.3Z",
    transform: "translate(-3166.688 -2610.618)",
    fill: "#083167"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1005",
    "data-name": "Group 1005",
    transform: "translate(0 56.457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1004",
    "data-name": "Group 1004"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1003",
    "data-name": "Group 1003"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1002",
    "data-name": "Group 1002"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2232",
    "data-name": "Path 2232",
    d: "M2309.316,3186.578s-12,1.556-16.011.3c-7.608-2.385-6.022-14.388-4.179-17.183,4.221-6.4,13.158-6.473,18.759.45Z",
    transform: "translate(-2287.601 -3164.919)",
    fill: "#ffb27d"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1014",
    "data-name": "Group 1014",
    transform: "translate(3.777 54.221)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1009",
    "data-name": "Group 1009",
    transform: "translate(0.283)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1008",
    "data-name": "Group 1008"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1007",
    "data-name": "Group 1007"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1006",
    "data-name": "Group 1006"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2233",
    "data-name": "Path 2233",
    d: "M2362,3137.8s-6.877-5.108-9.534-5.043c-2,.049-6.865,4.882-6.453,6.683.877,3.83,6.645-.026,6.645-.026s3.273,8.34,9.923,5.394Z",
    transform: "translate(-2345.992 -3132.759)",
    fill: "#ffb27d"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1013",
    "data-name": "Group 1013",
    transform: "translate(0 0.701)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1012",
    "data-name": "Group 1012"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1011",
    "data-name": "Group 1011"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1010",
    "data-name": "Group 1010"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2234",
    "data-name": "Path 2234",
    d: "M2353.23,3154.672c-2.831-1.043-4.144-4.325-4.514-5.432-2.628,1.6-6.072,2.653-6.76-.348-.349-1.523,2.328-4.515,4.4-5.99a.284.284,0,0,1,.329.463c-2.306,1.64-4.414,4.366-4.177,5.4a1.71,1.71,0,0,0,1.009,1.336c1.8.714,5.169-1.512,5.2-1.535a.283.283,0,0,1,.431.162c.012.042,1.2,4.278,4.275,5.412a.284.284,0,0,1-.2.532Z",
    transform: "translate(-2341.926 -3142.847)",
    fill: "#fe825c"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1102",
    "data-name": "Group 1102",
    transform: "translate(0 45.082)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1037",
    "data-name": "Group 1037",
    transform: "translate(0 61.733)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1017",
    "data-name": "Group 1017",
    transform: "translate(77.405 16.837)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1016",
    "data-name": "Group 1016"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2235",
    "data-name": "Path 2235",
    d: "M1472.173,2287.951s4.049,10.813,16.09,50.017l34.549-8.857,8.99,16.491s-42.188,20.58-54.871,20.128c-9.267-.329-22.15-19.092-22.15-19.092Z",
    transform: "translate(-1454.781 -2287.951)",
    fill: "#b7f2f6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1019",
    "data-name": "Group 1019",
    transform: "translate(145.39 51.704)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1018",
    "data-name": "Group 1018"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2236",
    "data-name": "Path 2236",
    d: "M2432.492,2795.786s11.9-6.893,15.868-6.383c5.329.685,18.051,17.638-7.122,22.19Z",
    transform: "translate(-2432.492 -2789.376)",
    fill: "#ffad94"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1022",
    "data-name": "Group 1022",
    transform: "translate(15.562)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1021",
    "data-name": "Group 1021"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1020",
    "data-name": "Group 1020"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2237",
    "data-name": "Path 2237",
    d: "M641.729,2061.389v117.028H594.113v-79.639H567.234c-.153-1.038-.3-2.081-.442-3.119-1.3-9.682-1.911-19.279-.845-26.5a21.9,21.9,0,0,1,2.586-8.2c2.666-4.373,12.28-8.224,21.065-10.947,2.779-.862,5.479-1.611,7.85-2.229,4.833-1.259,8.3-1.974,8.3-1.974l15.155,6.563Z",
    transform: "translate(-565.4 -2045.809)",
    fill: "#47cecd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1024",
    "data-name": "Group 1024",
    transform: "translate(16.108 1.974)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1023",
    "data-name": "Group 1023"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2238",
    "data-name": "Path 2238",
    d: "M601.428,2204.829V2125.19H574.549c-.153-1.038-.3-2.082-.442-3.12.306-1.611.658-3.21,1.044-4.8,1.253-5.15,2.893-10.561,1.361-15.637a20.65,20.65,0,0,0-3.25-6.058,21.9,21.9,0,0,1,2.586-8.2c2.666-4.373,12.28-8.224,21.065-10.947,2.779-.863,5.479-1.611,7.85-2.229a19.141,19.141,0,0,1,8.922,8.139c3.375,5.944,3.993,13.034,4.05,19.868s-.357,13.766,1.219,20.419c1.957,8.23,6.891,15.637,7.958,24.026,1.032,8.088-1.645,16.21-1.4,24.361s3.386,15.9,6.483,23.441c1.316,3.21,3.091,6.829,6.477,7.617a30.611,30.611,0,0,0,4.339.2c1.446.125,3.034.794,3.488,2.172a3.308,3.308,0,0,1,.1.391Z",
    transform: "translate(-573.262 -2074.194)",
    fill: "#36c2c6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1027",
    "data-name": "Group 1027",
    transform: "translate(14.961 4.201)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1026",
    "data-name": "Group 1026"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1025",
    "data-name": "Group 1025"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2239",
    "data-name": "Path 2239",
    d: "M566.621,2227.963c7.092,10.481,37.007,6.669,37.007,6.669,4.083-18.23,4.234-37.638,2.508-55.7a307.335,307.335,0,0,0-16.551-72.706v0c-1.388.432-2.8.89-4.2,1.373v0c-7.457,2.579-14.628,5.89-16.871,9.57-9.873,16.185,6.745,75.536,6.745,75.536S559.529,2217.482,566.621,2227.963Z",
    transform: "translate(-564.785 -2106.224)",
    fill: "#d0f4f8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1029",
    "data-name": "Group 1029",
    transform: "translate(32.385 4.201)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1028",
    "data-name": "Group 1028"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2240",
    "data-name": "Path 2240",
    d: "M812.986,2153.2l5.649-11.783-11.3-10.909,3.179-22.906v0c1.4-.483,2.809-.942,4.2-1.374v0a307.328,307.328,0,0,1,16.551,72.706Z",
    transform: "translate(-807.337 -2106.223)",
    fill: "#b7f2f6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1032",
    "data-name": "Group 1032",
    transform: "translate(71.061 6.563)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1031",
    "data-name": "Group 1031"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1030",
    "data-name": "Group 1030"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2241",
    "data-name": "Path 2241",
    d: "M1374.118,2222.784c1.526,15.482,2.678,30.763,2.953,43.455h14.067l-2.267-53.255-1.591-62.515-19.707-8.531-4.029-1.745s6.569,41.967,10.573,82.588Z",
    transform: "translate(-1363.545 -2140.193)",
    fill: "#d0f4f8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1034",
    "data-name": "Group 1034",
    transform: "translate(71.061 6.563)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1033",
    "data-name": "Group 1033"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2242",
    "data-name": "Path 2242",
    d: "M1380.87,2179.8l-6.752,42.985c-4-40.621-10.573-82.588-10.573-82.588l4.029,1.745,10.615,17.7-4.068,11.193Z",
    transform: "translate(-1363.545 -2140.193)",
    fill: "#b7f2f6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1036",
    "data-name": "Group 1036",
    transform: "translate(0 13.103)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1035",
    "data-name": "Group 1035"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2243",
    "data-name": "Path 2243",
    d: "M369.878,2233.5s-16.34,2.688-18.921,43.25c-1.291,20.293-2.7,32.106,0,37.573,1.23,2.509,3.669,1.4,8.041,3.129,14.234,6,57.471,5.261,57.471,5.261l1.59-19.4-40.285-8.316,1.606-19.115C382.293,2245.078,382.627,2249.526,369.878,2233.5Z",
    transform: "translate(-349.416 -2233.496)",
    fill: "#b7f2f6"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1076",
    "data-name": "Group 1076",
    transform: "translate(40.166)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1039",
    "data-name": "Group 1039",
    transform: "translate(4.052 19.829)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1038",
    "data-name": "Group 1038"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2244",
    "data-name": "Path 2244",
    d: "M998.558,1482.123l-.1,6.955-2.6,13.643-17.989-14.931-.1-8.707c-.012-.006-.012-.012-.012-.012v-13.135c-.5-8.5-.2-14.961.934-19.742l31.477-3.028a97.533,97.533,0,0,1,1.7,19.022c-.158,7.125.314,18.874-3.132,19.935S998.558,1482.123,998.558,1482.123Z",
    transform: "translate(-977.523 -1443.166)",
    fill: "#ef8f6a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1042",
    "data-name": "Group 1042"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1041",
    "data-name": "Group 1041"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1040",
    "data-name": "Group 1040"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2245",
    "data-name": "Path 2245",
    d: "M922.326,1192.884s-10.256-27,6.662-22.879c0,0,1.57-8.778,14.464-8.766,9.625.009,13.5-1.9,14.969-3.077a.694.694,0,0,1,1.126.421c.4,2.519.485,7.838-5.752,8.793,0,0,23.123,2.748,3.7,22.593l-.525-4.575s-11.244,7.046-22.85-5.257c0,0,2.015,8.236-6.382,11.02Z",
    transform: "translate(-919.246 -1158.005)",
    fill: "#083167"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1046",
    "data-name": "Group 1046",
    transform: "translate(1.737 29.796)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1045",
    "data-name": "Group 1045"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1044",
    "data-name": "Group 1044"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1043",
    "data-name": "Group 1043"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2246",
    "data-name": "Path 2246",
    d: "M952.38,1592.567c.19,3.816-1.654,7.7-3.9,7.812s-4.042-3.591-4.231-7.407,1.211-6.342,3.454-6.454S952.19,1588.751,952.38,1592.567Z",
    transform: "translate(-944.231 -1586.514)",
    fill: "#ef8f6a"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1048",
    "data-name": "Group 1048",
    transform: "translate(3.205 32.42)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1047",
    "data-name": "Group 1047"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2247",
    "data-name": "Path 2247",
    d: "M965.844,1628.6a.5.5,0,0,1-.5-.478c-.111-2.241.823-3.8,2.326-3.873,1.562-.083,2.814,1.475,2.921,3.612a.5.5,0,0,1-1,.05c-.089-1.782-1.027-2.691-1.866-2.658-.888.044-1.452,1.2-1.371,2.819a.5.5,0,0,1-.477.527Z",
    transform: "translate(-965.334 -1624.243)",
    fill: "#e47960"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1075",
    "data-name": "Group 1075",
    transform: "translate(10.492 51.018)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1074",
    "data-name": "Group 1074"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2254",
    "data-name": "Path 2254",
    d: "M1090.785,1960.521a40.917,40.917,0,0,1-14.592-7.772s3.183,8.57,14.581,11.651Z",
    transform: "translate(-1076.193 -1952.75)",
    fill: "#e47960"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1101",
    "data-name": "Group 1101",
    transform: "translate(42.895 34.496)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1087",
    "data-name": "Group 1087",
    transform: "translate(1.545)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1081",
    "data-name": "Group 1081",
    transform: "translate(0.276)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1080",
    "data-name": "Group 1080"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1079",
    "data-name": "Group 1079"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1078",
    "data-name": "Group 1078"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1077",
    "data-name": "Group 1077"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2255",
    "data-name": "Path 2255",
    d: "M1.58,1.941c.469,1.052.532,2.048.143,2.234a4.82,4.82,0,0,0,1.65-1.286A1.741,1.741,0,0,0,2.127.012,4.957,4.957,0,0,0,0,.311C.4.159,1.108.882,1.58,1.941Z",
    fill: "#265784"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1086",
    "data-name": "Group 1086",
    transform: "translate(0 0.288)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1085",
    "data-name": "Group 1085"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1084",
    "data-name": "Group 1084"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1083",
    "data-name": "Group 1083"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1082",
    "data-name": "Group 1082"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2256",
    "data-name": "Path 2256",
    d: "M.4,2.267c.476,1.067,1.189,1.8,1.591,1.624s.341-1.176-.135-2.243S.668-.146.266.025-.075,1.2.4,2.267Z",
    fill: "#dff0ff"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1092",
    "data-name": "Group 1092",
    transform: "translate(0 1.736)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1091",
    "data-name": "Group 1091"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1090",
    "data-name": "Group 1090"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1089",
    "data-name": "Group 1089"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1088",
    "data-name": "Group 1088"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2257",
    "data-name": "Path 2257",
    d: "M28.366,38.11a5.819,5.819,0,0,0,.8-.054,8.606,8.606,0,0,0,6.121-3.684c4.795-6.865,1.269-21.7,1.128-22.278a.48.48,0,0,0-.575-.346.466.466,0,0,0-.354.561c.034.138,3.569,15.014-.989,21.538a7.681,7.681,0,0,1-5.465,3.285,4.96,4.96,0,0,1-.685.047c-9.738,0-24.646-27-27.287-33.929a1.489,1.489,0,0,1,.8-1.9L2.876.889a.462.462,0,0,0,.231-.62A.482.482,0,0,0,2.472.044L1.452.509A2.408,2.408,0,0,0,.16,3.575C2.177,8.869,17.484,38.108,28.366,38.11Z",
    fill: "#265784"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1095",
    "data-name": "Group 1095",
    transform: "translate(16.542 31.411)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1094",
    "data-name": "Group 1094"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1093",
    "data-name": "Group 1093"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2258",
    "data-name": "Path 2258",
    d: "M20.83.461A1.179,1.179,0,0,0,19.887,0h-.031a1.183,1.183,0,0,0-1.131.831,10.355,10.355,0,0,1-1.365,2.948,6.99,6.99,0,0,1-4.973,2.987A4.29,4.29,0,0,1,11.8,6.8h0C9.245,6.8,5.878,4.586,2.063.387A1.2,1.2,0,0,0,1.182,0,1.168,1.168,0,0,0,.106.68,1.121,1.121,0,0,0,.3,1.92C4.654,6.706,8.531,9.133,11.825,9.134a6.7,6.7,0,0,0,.9-.061,9.3,9.3,0,0,0,6.613-3.983,12.712,12.712,0,0,0,1.684-3.607A1.144,1.144,0,0,0,20.83.461Z",
    fill: "#265784"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1100",
    "data-name": "Group 1100",
    transform: "translate(29.579 38.522)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1099",
    "data-name": "Group 1099"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1098",
    "data-name": "Group 1098"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1097",
    "data-name": "Group 1097"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1096",
    "data-name": "Group 1096"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2259",
    "data-name": "Path 2259",
    d: "M5.793,10.51a1.454,1.454,0,0,0,.856-.277,1.376,1.376,0,0,0,.292-1.958A26.377,26.377,0,0,1,2.807,1,1.442,1.442,0,0,0,1.025.058,1.393,1.393,0,0,0,.059,1.793,28.432,28.432,0,0,0,4.644,9.947,1.442,1.442,0,0,0,5.793,10.51Z",
    fill: "#265784"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1108",
    "data-name": "Group 1108",
    transform: "translate(194.024 114.717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1107",
    "data-name": "Group 1107"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1106",
    "data-name": "Group 1106"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1105",
    "data-name": "Group 1105"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1104",
    "data-name": "Group 1104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1103",
    "data-name": "Group 1103"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2260",
    "data-name": "Path 2260",
    d: "M3424.784,2275.135h-77.637s-2.683-5.28-2.836-7.231c-2.235-29.17-6.875-94.647,2.836-104.9,22.063-23.306,62.033-9.194,67.07-7.187l10.34,71.551.017,3.783-2.94,19.645Z",
    transform: "translate(-3341.226 -2149.752)",
    fill: "#ff6b36"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1110",
    "data-name": "Group 1110",
    transform: "translate(215.691 196.115)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1109",
    "data-name": "Group 1109"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2261",
    "data-name": "Path 2261",
    d: "M3706.9,3364.464c-7.256.688-10.082-.134-12.121,0,.127-16.321-2.932-17.723-20.636-16.684-24.357.108-28.925-5.807-28.925-5.807l61.682-21.622-2.812,20.919Z",
    transform: "translate(-3645.216 -3320.352)",
    fill: "#e54b13"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1113",
    "data-name": "Group 1113",
    transform: "translate(215.692 160.784)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1112",
    "data-name": "Group 1112"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1111",
    "data-name": "Group 1111"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2262",
    "data-name": "Path 2262",
    d: "M3680.951,2840.483c-.416,5.033-2.71,10.021-7.071,12.275-2.517,1.3-5.54,4.667-8.464,4.729-7.971.17-19.622-.286-20.185,1.932-.347,1.365,27.348,5.146,39.848,3.232,2.686-.411,5.483-1.095,7.254-3.057a8.842,8.842,0,0,0,1.958-6.178,24.754,24.754,0,0,0-1.388-6.741c-2.581-8.141-1.557-17.026-6.135-24.382-.392-.629-.881-1.32-1.591-1.458-3.113-.6-4.8-.431-5.279,8.39C3679.689,2833.032,3681.259,2836.757,3680.951,2840.483Z",
    transform: "translate(-3645.228 -2820.632)",
    fill: "#e54b13"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1152",
    "data-name": "Group 1152",
    transform: "translate(177.536 43.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1115",
    "data-name": "Group 1115",
    transform: "translate(3.466 22.442)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1114",
    "data-name": "Group 1114"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2263",
    "data-name": "Path 2263",
    d: "M3147.483,1495.868c2.515,6.084,16.1,8.554,20.824,6.6s-1.189-7.594-3.7-13.678-8.394-9.434-13.12-7.48S3144.965,1489.777,3147.483,1495.868Z",
    transform: "translate(-3146.343 -1480.753)",
    fill: "#784645"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1119",
    "data-name": "Group 1119",
    transform: "translate(9.968 9.927)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1118",
    "data-name": "Group 1118"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1117",
    "data-name": "Group 1117"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1116",
    "data-name": "Group 1116"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2264",
    "data-name": "Path 2264",
    d: "M3302.811,1360.111l-20.585,15.93-4.282-15.764-1.081-3.983v-.006l-.178.109a.46.46,0,0,1-.069.04v.006c-1.408.862-6.637,5.724-9.453,4.9s-13.186-14.067-15.724-27.34c-1.813-9.483,0-15.762,0-15.762s11.034-17.47,22.528-17.47c10.131,0,19.907,31.125,22.079,38.458Z",
    transform: "translate(-3250.633 -1300.769)",
    fill: "#ffb27d"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1121",
    "data-name": "Group 1121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1120",
    "data-name": "Group 1120"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2265",
    "data-name": "Path 2265",
    d: "M3152.374,1207.934s6.269-49.96-17.265-49.93a9.747,9.747,0,0,0-7.942,6.354s-33.245-9.823-30.513,18.554c1.129,11.728,10.613,2.487,10.613,2.487s-3.7,14.926,11.276,1.084c0,0,2.836,8.384,15.09-1.084,0,0-5.333,9.707,5.333,8.345,0,0,5.263-4.087,8.51,7.6Z",
    transform: "translate(-3096.494 -1158.004)",
    fill: "#784645"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1125",
    "data-name": "Group 1125",
    transform: "translate(41.172 30.413)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1124",
    "data-name": "Group 1124"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1123",
    "data-name": "Group 1123"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1122",
    "data-name": "Group 1122"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_66",
    "data-name": "Ellipse 66",
    cx: 5.849,
    cy: 10.128,
    rx: 5.849,
    ry: 10.128,
    fill: "#ffb27d"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1137",
    "data-name": "Group 1137",
    transform: "translate(36.198 56.456)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1136",
    "data-name": "Group 1136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1135",
    "data-name": "Group 1135"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1134",
    "data-name": "Group 1134"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2268",
    "data-name": "Path 2268",
    d: "M3617.8,1981.619l-.726-2.676c2.63-1.49,4.727-4.862,6.6-9.024C3623.675,1969.918,3625.327,1977.108,3617.8,1981.619Z",
    transform: "translate(-3617.071 -1969.918)",
    fill: "#db7447"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1144",
    "data-name": "Group 1144",
    transform: "translate(44.682 35.153)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1143",
    "data-name": "Group 1143"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1142",
    "data-name": "Group 1142"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1141",
    "data-name": "Group 1141"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1140",
    "data-name": "Group 1140"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1139",
    "data-name": "Group 1139"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1138",
    "data-name": "Group 1138"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2269",
    "data-name": "Path 2269",
    d: "M3744.38,1668.406a.562.562,0,0,0,.561-.534c.124-2.5-.92-4.243-2.6-4.326-1.745-.093-3.145,1.648-3.263,4.035a.562.562,0,1,0,1.122.056c.1-1.991,1.148-3.006,2.085-2.969.992.05,1.621,1.344,1.532,3.149a.562.562,0,0,0,.533.589Z",
    transform: "translate(-3739.079 -1663.542)",
    fill: "#db7447"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1151",
    "data-name": "Group 1151",
    transform: "translate(45.951 38.708)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1150",
    "data-name": "Group 1150"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1149",
    "data-name": "Group 1149"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1148",
    "data-name": "Group 1148"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1147",
    "data-name": "Group 1147"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1146",
    "data-name": "Group 1146"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1145",
    "data-name": "Group 1145"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2270",
    "data-name": "Path 2270",
    d: "M3759.5,1718.352c.833-1.1.245-3.062.175-3.282a.562.562,0,0,0-1.071.338h0a3.147,3.147,0,0,1,0,2.265c-.085.111-.247.257-.69.242a.562.562,0,0,0-.041,1.123A1.861,1.861,0,0,0,3759.5,1718.352Z",
    transform: "translate(-3757.329 -1714.677)",
    fill: "#db7447"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1156",
    "data-name": "Group 1156",
    transform: "translate(190.734 196.014)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1155",
    "data-name": "Group 1155"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1154",
    "data-name": "Group 1154"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1153",
    "data-name": "Group 1153"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2271",
    "data-name": "Path 2271",
    d: "M3316.258,3323.456l-.307,16.722c-22.492,6.868-24.94-8.421-23.089-16.722.666-2.986,2.769,4.912,6.441,6.249,3.26,1.183,8.08-4.116,8.08-4.116s-6.147-3.4-5.239-5.18C3304.542,3315.705,3316.258,3323.456,3316.258,3323.456Z",
    transform: "translate(-3292.367 -3318.894)",
    fill: "#ffb27d"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1160",
    "data-name": "Group 1160",
    transform: "translate(213.734 120.728)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1159",
    "data-name": "Group 1159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1158",
    "data-name": "Group 1158"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1157",
    "data-name": "Group 1157"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2272",
    "data-name": "Path 2272",
    d: "M3690.05,2325.945c-.177,3.1-16.949,6.152-33.043,7.688s-28.541,1.477-38.593,0c-1.791,0-1.791-19.384,0-19.384l45.034-4.265s-7.841-39.764-9.521-47.324c1.68-12.6,9.241-32.2,20.006-25.277,8.341,5.348,11.849,17.914,14.063,40.441S3690.891,2305.783,3690.05,2325.945Z",
    transform: "translate(-3617.071 -2235.94)",
    fill: "#ff6b36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2288",
    "data-name": "Path 2288",
    d: "M1.9,78.224s-3.977,9.611,0,19.055c3.451-.085,4.039.209,6.462,0,1.616-4.764-4.805-16.073,0-19.055S1.9,78.224,1.9,78.224Z",
    transform: "translate(0 -0.019)",
    fill: "#9b3511"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1163",
    "data-name": "Group 1163",
    transform: "translate(78.102 126.361)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1162",
    "data-name": "Group 1162"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1161",
    "data-name": "Group 1161"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2273",
    "data-name": "Path 2273",
    d: "M1534.276,2377.793c-2.5,6.511-6.175,10.147-10.953,10.827a14.885,14.885,0,0,1-2.055.153c-6.858,0-8.372-5.655-9.4-9.512l-.167-.618c-.836-3.08,2.622-4.475-1.34-5.292-3.112-.635-9.706.085-9.6,1.277-7.3,7.759-22.5,6.743-38.524.328-16.15-6.46-30.028-22.466-37.127-42.811a.9.9,0,0,1,.413-1.106.706.706,0,0,1,.959.471c6.942,19.9,20.486,35.534,36.237,41.841,15.471,6.194,30.641,7.616,37.5.316l2.051-1.989c1.652-1.753,4.609-.765,8.345,0,4.734.97,1.556,3.006,2.5,6.455l.167.629c1.156,4.322,2.468,9.217,9.872,8.168,4.243-.6,7.547-3.936,9.813-9.92C1533.372,2377.282,1533.814,2377.543,1534.276,2377.793Z",
    transform: "translate(-1425.052 -2330.977)",
    fill: "#265784"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1165",
    "data-name": "Group 1165",
    transform: "translate(152.749 156.925)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1164",
    "data-name": "Group 1164"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2274",
    "data-name": "Path 2274",
    d: "M2452.664,2830.354c1.638,3.246-1.751,8.262-7.568,11.2s-11.865,2.685-13.5-.561,1.749-8.267,7.566-11.2S2451.023,2827.1,2452.664,2830.354Z",
    transform: "translate(-2431.179 -2827.741)",
    fill: "#083167"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1175",
    "data-name": "Group 1175",
    transform: "translate(152.84 151.613)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1174",
    "data-name": "Group 1174"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2279",
    "data-name": "Path 2279",
    d: "M2447.893,2762.973c-1.833,1.46-6.106-2.754-6.106-2.754-.678,3.306-4.387,4.726-7.287,5.208l-2.007-3.644s5.923-9.95,9.856-8.869S2449.62,2761.6,2447.893,2762.973Z",
    transform: "translate(-2432.492 -2752.832)",
    fill: "#ffad94"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1177",
    "data-name": "Group 1177",
    transform: "translate(164.09 163.147)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1176",
    "data-name": "Group 1176"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2280",
    "data-name": "Path 2280",
    d: "M2605.907,2918c-1.667-1.956-4.416-1.612-6.643-.2-4.115,2.6-6.362,6.748-4.066,9.409.949,1.1,2.787.718,3.955-.289l5.873-5.067C2606.322,2920.737,2606.754,2919,2605.907,2918Z",
    transform: "translate(-2594.278 -2916.641)",
    fill: "#ffad94"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1179",
    "data-name": "Group 1179",
    transform: "translate(53.137 187.919)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1178",
    "data-name": "Group 1178"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2281",
    "data-name": "Path 2281",
    d: "M1308.875,3206.342l-1.388,16.685c22.012,8.278,25.216-1.259,23.894-9.66-.975-6.194-13.783-4.334-13.783-4.334s6.349-3,5.556-4.838C1321.057,3199.348,1308.875,3206.342,1308.875,3206.342Z",
    transform: "translate(-1307.487 -3202.484)",
    fill: "#ef8f6a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3298",
    "data-name": "Group 3298",
    transform: "translate(95.125 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_989",
    "data-name": "Group 989",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_988",
    "data-name": "Group 988",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2227",
    "data-name": "Path 2227",
    d: "M2142.522,1726.944a37.589,37.589,0,1,1-37.588-37.589A37.585,37.585,0,0,1,2142.522,1726.944Z",
    transform: "translate(-2067.345 -1689.356)",
    fill: "#d0f4f8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1184",
    "data-name": "Group 1184",
    transform: "translate(7.33 7.329)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1181",
    "data-name": "Group 1181",
    transform: "translate(0.339 0.338)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1180",
    "data-name": "Group 1180"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2282",
    "data-name": "Path 2282",
    d: "M2183.87,1775.954a29.92,29.92,0,1,1-29.92-29.92A29.917,29.917,0,0,1,2183.87,1775.954Z",
    transform: "translate(-2124.031 -1746.034)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1183",
    "data-name": "Group 1183",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1182",
    "data-name": "Group 1182"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2283",
    "data-name": "Path 2283",
    d: "M2150.21,1802.467a30.254,30.254,0,1,1,30.258-30.25A30.288,30.288,0,0,1,2150.21,1802.467Z",
    transform: "translate(-2119.952 -1741.959)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1187",
    "data-name": "Group 1187",
    transform: "translate(9.589 21.301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1186",
    "data-name": "Group 1186"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1185",
    "data-name": "Group 1185"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2284",
    "data-name": "Path 2284",
    d: "M2218.69,1964.185h-.023a.778.778,0,0,1-.75-.686l-2.683-22.6-2.6,11.216a.779.779,0,0,1-1.433.213l-2.381-4.135-2.208,3.741a.778.778,0,0,1-.67.382h-14.271a.778.778,0,1,1,0-1.557H2205.5l2.66-4.509a.781.781,0,0,1,.671-.382h0a.778.778,0,0,1,.671.39l2.06,3.578,3.161-13.628a.767.767,0,0,1,.8-.6.778.778,0,0,1,.73.685l2.586,21.789,1.808-10.207a.779.779,0,0,1,.7-.639.769.769,0,0,1,.8.507l1.256,3.419h22.708a.778.778,0,1,1,0,1.557H2222.86a.78.78,0,0,1-.731-.51l-.448-1.222-2.224,12.555A.778.778,0,0,1,2218.69,1964.185Z",
    transform: "translate(-2190.892 -1935.606)",
    fill: "#f77777"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1189",
    "data-name": "Group 1189",
    transform: "translate(49.488 48.711)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1188",
    "data-name": "Group 1188"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2285",
    "data-name": "Path 2285",
    d: "M2621.969,2223.586h-12.641a.389.389,0,0,1,0-.778h12.641a.389.389,0,1,1,0,.778Z",
    transform: "translate(-2608.939 -2222.808)",
    fill: "#f77777"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1191",
    "data-name": "Group 1191",
    transform: "translate(49.488 51.462)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1190",
    "data-name": "Group 1190"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2286",
    "data-name": "Path 2286",
    d: "M2617.644,2252.406h-8.316a.389.389,0,0,1,0-.778h8.316a.389.389,0,1,1,0,.778Z",
    transform: "translate(-2608.939 -2251.628)",
    fill: "#f77777"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1193",
    "data-name": "Group 1193",
    transform: "translate(49.488 54.213)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1192",
    "data-name": "Group 1192"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2287",
    "data-name": "Path 2287",
    d: "M2614.435,2281.235h-5.107a.389.389,0,0,1,0-.779h5.107a.389.389,0,0,1,0,.779Z",
    transform: "translate(-2608.939 -2280.456)",
    fill: "#f77777"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlan4);
export default __webpack_public_path__ + "static/media/plan4.576c67b04c49cc701c62ba446ae87833.svg";
export { ForwardRef as ReactComponent };